import { GET_OWNER_LIST } from '../types/types';


export const setOwnerList = (data) => ({
    payload: data,
    type: GET_OWNER_LIST,
});
